<template>

  <el-dialog
      title="默认配置"
      :visible.sync="visible"
      destroy-on-close
      width="450px"
      v-if="visible"
      :before-close="handleClose">
    <el-form :model="form" ref="ruleForm" :rules="rules">
      <el-form-item label="默认配置" label-width="100px" prop="config">
        <el-select v-model="form.config" placeholder="请选择">
          <el-option
              v-for="item in configOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleSubmit">确 定</el-button>
  </span>

  </el-dialog>

</template>

<script>

export default {
  name: "defaultOption",
  props:{
    visible: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      form: {
        config: ''
      },
      rules: {
        config: [{ required: true, message: "请选择默认配置", trigger: "blur" }],
      },
      configOptions:[
        {
          value: 'RSA',
          label: '默认使用RSA认证'
        },
        {
          value: 'SM2',
          label: '默认使用国密认证'
        },
        {
          value: '0',
          label: '每次签章询问'
        },
      ]
    }
  },
  methods:{
    handleSubmit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$http.post(this.$api.user.updateServiceInfo, this.form).then(res => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg);
              this.$emit('getServiceInfo')
              this.updateDialog(false)
            }else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    open(e,type){
      let form = {
        id: e.id,
        config: e.config
      }
      if (type === 'rsa'){
        this.configOptions = [
          {
            value: 'RSA',
            label: '默认使用RSA认证'
          },
          {
            value: 'SM2',
            label: '默认使用国密认证'
          },
          {
            value: '0',
            label: '每次签章询问'
          },
        ]
      }else if (type === 'timeStamp'){
        this.configOptions = [
          {
            value: '1',
            label: '使用'
          },
          {
            value: '0',
            label: '不使用'
          },
        ]
      }
      this.form = form
      this.updateDialog(true)
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },

    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">

</style>
